export default __webpack_public_path__ + "static/media/Iceland-5.49f23714.webp";